import { nameTipsTs } from "../../../types/types";

export const nameTips = (state: number): nameTipsTs => {
    let temp = {
        color: '#ff7200',
        text: '未开始'
    }
    switch (state) {
        case 0:
            temp = {
                color: '#ff7200',
                text: '未开始'
            }
            break;
        case 1:
            temp = {
                color: '#0099ff',
                text: '进行中'
            }
            break;
        default:
            temp = {
                color: '#999999',
                text: '已结束'
            }
            break;
    }
    return temp
}
